import React, { useState, useEffect } from "react";
import { EventsType } from "../Common/Types/types";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import EventsGrid from "./Grid";

interface EventsGridWidgetProps {
  id: string;
  header: string;
  term: string;
  filteredEvents: EventsType[];
  loading: boolean;
  error: string;
  showWorkLogs: any;
}

const EventsGridWidget = (props: EventsGridWidgetProps) => {
  const [eventsData, updateEventsData] = useState<EventsType[]>(null);

  useEffect(() => {
    updateEventsData(props.filteredEvents);
  }, [props.filteredEvents]);

  if (props.loading) {
    return <Spinner text="data" />;
  } else if (eventsData != null && eventsData.length == 0) {
    return (
      <ErrorMessage
        text={"No data found for selected filters."}
        id={props.id}
        header={props.header}
      />
    );
  } else if (props.error) {
    return (
      <ErrorMessage text={props.error} id={props.id} header={props.header} />
    );
  } else if (eventsData != null && eventsData.length > 0) {
    return <EventsGrid data={eventsData} showWorkLogs={props.showWorkLogs} />;
  }
};
export default EventsGridWidget;
